/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Col, Form, Row } from "react-bootstrap";
import styled from "styled-components";

import { ordersActions } from "_store/actions";
import breakpoints from "_constants/breakpoints";

import Table from "containers/Table/Table";
import LogoCard from "components/LogoCard";

const Container = styled.div`
  padding: 36px 32px 36px;
  margin-bottom: 24px;
  background: #ffffff;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);

  @media (max-width: ${breakpoints.mobileM}) {
    padding: 26px 12px 12px;

    & p {
      font-size: 14px;
      text-align: justify;
    }
  }
`;
const CardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  align-items: center;
  background-color: #fafafa;
  padding: 4px;

  margin-bottom: 24px;
  @media (max-width: ${breakpoints.tablet}) {
    justify-content: start;
  }
`;

const RequestContainer = styled(Row)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* margin-top: 36px; */
`;
const RequestForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  /* width: 60%; */

  & #request-textarea {
    width: 100%;
    min-height: 120px;
    max-height: 500px;
  }

  & .request-revision-title {
    color: #7b848d;
    font-weight: bold;
    font-family: "Montserrat";
  }
`;
const RequestButton = styled(Button)``;

const Title = styled.div`
  font-family: "Montserrat";
  margin-bottom: 12px;
`;

function LogoDesignService(props) {
  const dispatch = useDispatch();

  const { orderId, productId, processingOption, files, reviewRequests = [] } = props;

  const [requestMessage, setRequestMessage] = useState("");

  const conceptFiles = files?.filter((file) => file?.type?.includes("LOGO_CONCEPT")) || [];
  const sourceFiles = files?.filter((file) => file?.type?.includes("LOGO_SOURCE")) || [];
  const sampleFiles = files?.filter((file) => file?.type?.includes("LOGO_SAMPLE")) || [];

  const handleDownload = ({ productId, filename, fileId }) => {
    if (productId) {
      dispatch(ordersActions.getFileFromProduct(orderId, productId, filename, true));
    } else {
      dispatch(ordersActions.getFile(orderId, fileId, true));
    }
  };

  function getRevisionsLeft() {
    switch (processingOption) {
      case "BASIC":
        return {
          disableRequest: 2 - reviewRequests.length < 1,
          count: 2 - reviewRequests.length,
          message: `${2 - reviewRequests.length} Left`,
        };

      case "STANDARD":
      case "STANDARD_PACKAGE":
        return {
          disableRequest: 4 - reviewRequests.length < 1,
          count: 4 - reviewRequests.length,
          message: `${4 - reviewRequests.length} Left`,
        };

      case "ULTIMATE":
        return { disableRequest: false, count: Infinity, message: "Unlimited" };

      default:
        return { disableRequest: true, count: null, message: "N/A Left" };
    }
  }

  function handleSendRevision(e) {
    e.preventDefault();

    if (requestMessage) {
      dispatch(
        ordersActions.customerAction({
          orderId,
          productId,
          actionType: "REQUEST_LOGO_REVISION",
          message: requestMessage,
        })
      );

      setRequestMessage("");
    }
  }

  const columnsRevision = [
    { width: 130, label: "DATE", key: "timestamp", format: "MMM DD, YYYY hh:mm" },
    { label: "REQUEST", key: "message", multiline: true },
  ];

  return (
    <Container>
      <Row>
        <Col sm={12} md={6}>
          <Title>Logo Concepts</Title>
          <CardsContainer>
            {conceptFiles?.map((file, idx) => (
              <LogoCard
                key={`card-${file?.filename}`}
                index={idx}
                fileType={file?.type}
                handleDownload={handleDownload}
                {...file}
                {...props}
              />
            ))}
            {conceptFiles.length < 1 && <div style={{ color: "gray" }}>No Logo Concepts Uploaded Yet.</div>}
          </CardsContainer>

          {["STANDARD", "STANDARD_PACKAGE", "ULTIMATE"].includes(processingOption) && (
            <>
              <br />
              <Title>Logo Sources</Title>
              <CardsContainer>
                {sourceFiles?.map((file, idx) => (
                  <LogoCard
                    key={`card-${file?.filename}`}
                    index={idx}
                    fileType={file?.type}
                    handleDownload={handleDownload}
                    {...file}
                    {...props}
                  />
                ))}
                {sourceFiles.length < 1 && <div style={{ color: "gray" }}>No Logo Sources Uploaded Yet.</div>}
              </CardsContainer>
            </>
          )}

          {["ULTIMATE"].includes(processingOption) && (
            <>
              <br />
              <Title>Logo Sample Marketing Packages</Title>
              <CardsContainer>
                {sampleFiles?.map((file, idx) => (
                  <LogoCard
                    key={`card-${file?.filename}`}
                    index={idx}
                    fileType={file?.type}
                    handleDownload={handleDownload}
                    {...file}
                    {...props}
                  />
                ))}
                {sampleFiles.length < 1 && (
                  <div style={{ color: "gray" }}>No Logo Sample Marketing Packages Uploaded Yet.</div>
                )}
              </CardsContainer>
            </>
          )}
        </Col>
        <Col sm={12} md={6}>
          <RequestContainer>
            <RequestForm onSubmit={handleSendRevision}>
              <Table data={reviewRequests} columns={columnsRevision} />
              <br />
              <div className="request-revision-title">Request Revision ({getRevisionsLeft().message})</div>
              <Form.Control
                id="request-textarea"
                required
                as="textarea"
                rows={3}
                disabled={getRevisionsLeft().disableRequest}
                value={requestMessage}
                onChange={({ target: { value } }) => setRequestMessage(value)}
              ></Form.Control>

              <RequestButton
                variant="success"
                type="submit"
                disabled={getRevisionsLeft().disableRequest || !requestMessage}
              >
                Request
              </RequestButton>
            </RequestForm>
          </RequestContainer>
        </Col>
      </Row>
    </Container>
  );
}

LogoDesignService.propTypes = {
  orderId: PropTypes.string,
  productId: PropTypes.string,
  files: PropTypes.array,
};

export default LogoDesignService;
